'use strict';

class ViewportSpy {

	constructor() {
		this.viewportData = {
			mode: -1,
			width: -1,
			height: -1,
			screenRotated: false,
			pixelRatio: 1
		};

		this.breakpoints = [
			{mode: 0, width: 0},
			{mode: 1, width: 480},
			{mode: 2, width: 768},
			{mode: 3, width: 960},
			{mode: 4, width: 1280},
			{mode: 5, width: 99999}];

		this._callbacks = [];
		this._restrictResize = bowser.mobile || bowser.tablet;
		this._recentOrientChange = false;
		this._recentResize = false;

		_.bindAll(this, 'onOrientationChange', 'onResize', 'update', 'register', 'unregister');

		$(window).on("orientationchange", this.onOrientationChange);
		$(window).on("resize", this.onResize);
		this.update();
	}

	onOrientationChange() {
		this.viewportData.screenRotated = window.orientation == 90 || window.orientation == -90;

		if(this._recentResize){
			this.update();
		} else {
			this._recentOrientChange = true;
			setTimeout(() => { this._recentOrientChange = false; }, 500);
		}
	}

	onResize(){
		if(!this._restrictResize || this._recentOrientChange){
			this.update();
		} else {
			this._recentResize = true;
			setTimeout(() => { this._recentResize = false; }, 500);
		}
	}

	update() {
		this._recentOrientChange = false;
		this._recentResize = false;
		this.viewportData.pixelRatio = window.devicePixelRatio || 1;

		let dirty = false;
		let ww = $(window).width();
		let wh =  $(window).height();

		if (this.viewportData.width != ww) {
			this.viewportData.width = ww;
			this.viewportData.mode = _.find(this.breakpoints, o => { return this.viewportData.width < o.width; }).mode;
			dirty = true;
		}

		if (this.viewportData.height != wh) {
			this.viewportData.height = wh;
			dirty = true;
		}

		if(dirty) {
			this._callbacks.forEach(cb => cb(this.viewportData));
		}
	}

	register(callback)
	{
		this._callbacks.push(callback);
	}

	unregister(callback)
	{
		this._callbacks = _.without(this._callbacks, callback);
	}
}
